import { Flex as ChakraFlex, Spacer } from '@chakra-ui/react';
import { forwardRef } from 'react';

import { FlexDefaultProps, type FlexProps } from './Flex.types';
import { HFlex } from './HFlex';
import { VFlex } from './VFlex';

const Flex = forwardRef<HTMLDivElement, FlexProps>(({ ...props }, ref) => {
  return <ChakraFlex ref={ref} width="full" {...props} />;
});

Flex.displayName = 'Flex';
Flex.defaultProps = FlexDefaultProps;

const FlexNotation = Object.assign(Flex, { Spacer, V: VFlex, H: HFlex });
export { FlexNotation as Flex };
